const Form080SC = {
    stepName: {
        importantNotes: "重要事项",
        studentInfo: "学生资料",
        schoolUse: "学校资料",
        confirmation: "确认页",
    },
    title: {
        t1: "需要用户输入的表单字段",
        t2: "由校方填写",
    },
    studentName: "学生姓名",
    schoolName: "学校名称",
    schoolCode: "学校编号",
    class: "班级",
    birthDate: "出生日期",
    address: "地址",
    tel: "电话号码",
    strN: "学生编号",
    certificate: "身份证/出生证明书/护照号码",
    noOption: {
        hkId: "身份证号码",
        birthNo: "出生证明书号码",
        passNo: "护照号码",
    },
    employName: "雇主名称",
    employAddress: "雇主地址",
    workNature: "工作性质",
    workDate: "工作日期",
    workHours: "工作时间",
    aPOption: {
        am: "上午",
        pm: "下午",
    },
    wages: "工资",
    workSchedule: "相关证明文件（例如工作时间表）",
    date: "日期",

    validCertify: "在学证明书有效期",
    schoolTel: "学校电话",
    schoolAddress: "学校地址",
    classHours: "上课时间",
    schoolChop: "校印",

    from: "由",
    to: "时至",

    sign: {
        parentSign: "家长/监护人签署",
        parentAtt: "家长/监护人签名扫描",
        parentEle: "家长/监护人电子签名",
        parentName: "家长/监护人姓名",

        headSign: "校长签署",
        headAtt: "校长签名扫描",
        headEle: "校长电子签名",
        headName: "校长姓名",
    },
    nameOfSchoolHead: "校长姓名",
    attachment: "校长签名扫描",
    notes: {
        note: "本人已阅读、明白及同意上述条款及细则",
        n1: "时",
        n2: "本人拟为小儿/小女/受监护儿童申请在学证明书，以便能于上课时间以外从事工作。 该份工作的详情如下﹕",
        n3: "本人知悉申请表格及「在学证明书」均不收任何费用。",
        n4: "致 : 教育局局长",
        n5: "[缺课个案专责小组经办]",
        n6: "传真: 2520 0073",
        n7: "兹证明上述学生的资料正确，而该生的上学记录一向令人满意。根据本人的判断，上述工作将不会影响其学业表现。",
        n8: "本人拟签发在学证明书予该生的家长/监护人，该份证明书的有效期由",
        n9: " 为止。 请将有关证明书寄交本人，以便签发。",
        n10: "至",
    },
    wantSubmit: {
        w1: "我想提交这个申请表",
    },

    showPop: "学生已年满15岁。根据《僱佣条例》，有关申请并不适用。",

    schoolOption: {
        s1: "1",
        s2: "2",
    },

    errorMsg: { minDigit: "此项最少需要填写{{min}}个数字" },
};
export default Form080SC;
